import { render, staticRenderFns } from "./ListRewardAccessoryDetail.vue?vue&type=template&id=dd1a18e4&scoped=true&"
import script from "./ListRewardAccessoryDetail.vue?vue&type=script&lang=js&"
export * from "./ListRewardAccessoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./ListRewardAccessoryDetail.vue?vue&type=style&index=0&id=dd1a18e4&prod&scoped=true&lang=css&"
import style1 from "./ListRewardAccessoryDetail.vue?vue&type=style&index=1&id=dd1a18e4&prod&lang=css&"
import style2 from "./ListRewardAccessoryDetail.vue?vue&type=style&index=2&id=dd1a18e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1a18e4",
  null
  
)

export default component.exports